import React, { useState } from 'react'
import { MdPhotoCamera } from 'react-icons/md';
import { CreateMember } from '../../actions/Members/MemberAction';

const ModalSignupMember = () => {
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [telephone, settelephone] = useState("");
  const [coverPicture, setcoverPicture] = useState("https://cdn-icons-png.flaticon.com/512/5987/5987811.png");


  return (
    <div className=" modal fade " id="member" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-2" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content rounded-0">
          <div className="modal-header relative">
            <h6 className=" modal-title  text-primary text-uppercase display-7 text-uppercase mb-0 translatable" id="exampleModalLabel" style={{ maxWidth: "600px" }}>Devenir membre</h6>
            <button type="button" className="absolute top-3 right-4 btn btn-close text-2xl " data-bs-dismiss="modal" aria-label="Close">X</button>
          </div>
          <div className="modal-body container flex justify-center">

            <div className="flex justify-center row g-8">
              <div className="col-lg-9">
                <form onSubmit={(e) => {
                  e.preventDefault()
                  CreateMember(name, coverPicture, email, telephone, password)
                }}>
                  <div className="row g-3">
                    <div className="col-12 cursor-auto">
                      <input type="file" className="sr-only" accept=".JPG, .PNG,.JPEG" placeholder="photo" style={{ height: "55px" }} />
                      <label >
                        <img src={`${coverPicture}`} className="h-[55px] w-[55px] rounded-[50%]" />
                      </label>
                    </div>
                    <div className="col-12">
                      <input type="text" value={name} onChange={(e) => { setname(e.target.value) }} required className="form-control bg-light border-0 px-4 translatable" placeholder="Nom Complet" style={{ height: "55px" }} />
                    </div>
                    <div className="col-12">
                      <input type="email" value={email} onChange={(e) => { setemail(e.target.value) }} required className="form-control bg-light border-0 px-4 translatable" placeholder="Votre email" style={{ height: "55px" }} />
                    </div>
                    <div className="col-12">
                      <input type="number" value={telephone} onChange={(e) => { settelephone(e.target.value) }} required className="form-control bg-light border-0 px-4 translatable" placeholder="telephone" style={{ height: "55px" }} />
                    </div>
                    <div className="col-12">
                      <input type="password" value={password} onChange={(e) => { setpassword(e.target.value) }} required className="form-control bg-light border-0 px-4 translatable" placeholder="mot de passe .." style={{ height: "55px" }} />
                    </div>
                    <div className="col-12">
                      <button className="btn btn-outline-primary w-100 py-3 translatable" type="submit">Faire parti des membres</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalSignupMember;